import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '@views/features/dashboard/components/dashboard/dashboard.component';
import { HomeComponent } from '@views/public/home/home.component';

export const routes: Routes = [
  { path: '',
    component: HomeComponent,
    loadChildren: () => import('@views/public/public.module').then(x => x.PublicModule)
  },
  {
    path: '',
    loadChildren: () => import('@views/features/features.module').then(x => x.FeaturesModule)
  },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
